<template>
  <ul data-spy="affix"
      data-offset-top="10"
      class="department-menu nav nav-pills nav-stacked navbar-left clearfix"
      id="sidebar">
    <li v-for="department in departments"
        :class="{ active: department.isActive }"
        style="border-bottom: 1px solid rgba(22, 87, 138, 0.5);">
      <router-link :to="{ name: 'department', params: { departmentSlug: department.slug } }" :id="department.id">
        <i class="fa fa-leaf"></i> <strong>{{ department.name }}</strong>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  data: function () {
    return {}
  },

  computed: {
    departments() {
      return this.$store.getters.departments;
    }
  },

  methods: {
    isActive( departmentSlug ) {
      return (this.$route.params.departmentSlug === departmentSlug);
    }
  }
}
</script>